/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Intro_Notice_LabelInputs */

const es_privacy_policy_intro_notice_label = /** @type {(inputs: Privacy_Policy_Intro_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importante`)
};

const en_privacy_policy_intro_notice_label = /** @type {(inputs: Privacy_Policy_Intro_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Important`)
};

/**
* | output |
* | --- |
* | "Important" |
*
* @param {Privacy_Policy_Intro_Notice_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_intro_notice_label = /** @type {((inputs?: Privacy_Policy_Intro_Notice_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Intro_Notice_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_intro_notice_label(inputs)
	return en_privacy_policy_intro_notice_label(inputs)
});
export { privacy_policy_intro_notice_label as "privacy_policy.intro.notice_label" }